import React from 'react';
import { Navbar } from '../../components';
import { MagnetSummaryHeader } from '../../containers';

const MagnetSummary = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <MagnetSummaryHeader />
        </div>
    </div>
  )
}

export default MagnetSummary